import { CircularProgress, createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Card, Icons, MaterialPalette, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import type { WorkPackageFilesDocument } from '../../rxdb/workPackageFiles/workPackageFiles.types';
import { getImage } from '../../utilities/storageUtils';
import { useNotification } from '../../utilities/useNotification';
import { useOnlineStatus } from '../../utilities/useOnlineStatus';
import { downloadURI } from '../../utilities/utilityFunctions';
import OfflineDialog from '../OfflineDialog';

const useStyles = makeStyles(() =>
  createStyles({
    primaryColor: {
      color: `${MaterialPalette.primary.main}`,
    },
    card: {
      padding: 16,
    },
    cardDiv: {
      cursor: 'pointer',
    },
  }),
);

interface Props {
  data: WorkPackageFilesDocument;
}

const WorkPackageFileDetails: React.FC<Props> = ({ data }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [offline, setOffline] = useState<boolean>(false);
  const online = useOnlineStatus();
  const { errorNotification } = useNotification();

  const downloadWorkPackageFiles = async (filePath: string, fileName: string) => {
    if (online) {
      setOffline(false);
      setLoading(true);
      try {
        const slicedFilePath = filePath.charAt(0) === '/' ? filePath.slice(1) : filePath;
        const result = await getImage(slicedFilePath);
        const blobPath = await fetch(String(result))
          .then(r => r.blob())
          .then(e => {
            return e;
          });

        const path = URL.createObjectURL(blobPath);
        downloadURI(path, fileName);
        setLoading(false);
      } catch (error) {
        errorNotification('Error while downloading data please try again');
        setLoading(false);
      }
    } else {
      setOffline(true);
    }
  };
  return (
    <>
      <Card elevation={1} className={classes.card}>
        <div
          onClick={() => downloadWorkPackageFiles(data.filePath, data.fileName)}
          className={classes.cardDiv}
        >
          <Grid item container xs={12} alignItems="center">
            <Grid item xs={9}>
              <Typography>
                <Typography color="primary" variant="h4">
                  {data.fileName}
                </Typography>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Grid container justifyContent="flex-end" alignItems="center">
                {!loading ? (
                  <Icons.DownloadFeather color="primary" />
                ) : (
                  <CircularProgress className={classes.primaryColor} />
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Card>
      {offline && <OfflineDialog open={offline} onClose={() => setOffline(false)} />}
    </>
  );
};

export default observer(WorkPackageFileDetails);
